module.exports = __webpack_public_path__ + "img/box_8.80f61019.png";